module.exports = __webpack_public_path__ + "img/2.7c8a8c4f.jpg";